import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBlackBackgroundConfig } from '@/data/landingConfig/landingBlackBackgroundConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BlackBackground } from './schemaObject';

interface Props {}
const BlackBackground: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BlackBackground} />
			<LandingTemplate
				data={landingBlackBackgroundConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default BlackBackground;
